// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start();
require("@rails/activestorage").start();
require("channels");

require("chartkick");
require("chart.js");

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import { Turbo } from "@hotwired/turbo-rails";
if (!customElements.get("turbo-frame")) {
  window.Turbo = Turbo;
}

import "jquery";
import "bootstrap";
import "autolink";
import "challenges";
import "comments";
import "errors";
import "products";
import "files";
import "flashcards";
import "image_preview";
import "location";
import "nested_attributes";
import "orders_initializer";
import "orders_payment";
import "orders_promo_codes";
import "pagination";
import "profiles";
import "profile_achievements";
import "promotional_popups";
import "readmore";
import "selects";
import "tel_input";
import "text_fit";
import "time";
import "owl.carousel";
import "general";
import "geolocation";
import "access_resources";
import "job_postings_filter";
import "pathway_selector";
import "tracking_bulk_select";

import * as Bootstrap from "bootstrap";
window.bs = Bootstrap;

import Bridge from "bridge";
window.bridge = Bridge;

require("trix");
require("@rails/actiontext");

export function displaySpinner(spinner_element) {
  spinner_element.style.display = "inline-block";
}

export function hideSpinner(spinner_element) {
  spinner_element.style.display = "none";
}
